(function(){

  var comp = document.querySelector('.comp-map-summary');
  if(!comp) return;

  let loadmore = comp.querySelector('.js_loadmore'); 
  if(loadmore){

    loadmore.addEventListener('click', (e) => {
        
      var thisGroup   = parseInt(loadmore.dataset.chunk);
      var totalGroup  = parseInt(loadmore.dataset.chunks);
      if(thisGroup < (totalGroup-1)){
        var activeGroup = thisGroup + 1;
        console.log(activeGroup);
        comp.querySelector('.chunk_'+ activeGroup).style.display = 'block';

        console.log(totalGroup);
        if(activeGroup < (totalGroup - 1)) loadmore.dataset.chunk = activeGroup;
        else loadmore.style.display = 'none';
        
      } else {
        loadmore.style.display = 'none';
      }
  
    })

  }

})()